export const environment = {
  production: true,
  isExternal: false,
  msalConfig: {
    auth: {
      clientId: 'ac59f80a-20b8-435d-b672-0a358c0b7ae3',
      authority: 'https://login.microsoftonline.com/e043c45c-ec88-4ada-a7e9-6f6aaf1a8c35',
    },
  },
  apiConfig: {
    scopes: ['ac59f80a-20b8-435d-b672-0a358c0b7ae3/.default'],
    //scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  b2cPolicies: {
    names: {
      signUpSignIn: "",
      mfa: ""
    },
    authorities: {
      signUpSignIn: {
        authority: ""
      },
      mfa: {
        authority: ""
      }
    },
    authorityDomain: ""
  },
  apiUrl: 'https://ngenapi-prd.pplfirst.com/internal',
  mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
  wotcUrl: 'https://wotc.com/portal/public-partnerships-home-care-llc/f8850?noStartDate=1',
  apimSubScriptionKey: '6cbaa561d9774d40b25be6ca53385936',
  restrictedMenus: ["process_codes", "service_codes", "participant_provider_rates", "authorizations", "timesheets"],
  mfaTimeOutSeconds: 600
};